import { render, staticRenderFns } from "./ContactManageView.vue?vue&type=template&id=23e9a16e&"
import script from "./ContactManageView.vue?vue&type=script&lang=js&"
export * from "./ContactManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports